function handleAnimation( items ) {
    let i = 0;

    let intervalId = setInterval(() => {
        items[ i++ ].classList.add("is-visible");
        if ( i >= items.length ) {
            clearInterval( intervalId );
        }

    }, 130 );
}

function animateItems() {
    const animatedItems = document.querySelectorAll(".js-animated-item"); 
    handleAnimation( animatedItems );
}

class Selection {
    constructor() {
        this._form = document.querySelector(".js-select-form");
        this._submitButton = document.querySelector(".js-select-submit-button");
        this._submitButton.setAttribute( "disabled", true );
    }

    listenClicks() {
        this._form.addEventListener("click", e => {
            this._handleClicks( e.target );
            this._handleSUbmitButton();
        });
    }

    _handleClicks( element ) {
        if ( element.closest(".js-select-checkbox") ) {
            let checkbox;
            element = element.closest(".js-select-checkbox");
            element.classList.toggle("is-selected");
            checkbox = element.querySelector("input[type='checkbox']");
            checkbox.checked ? checkbox.checked = false : checkbox.checked = true;
        }

        if ( element.closest(".js-select-radio") ) {
            let radio;
            this._refreshItems();
            element = element.closest(".js-select-radio");
            element.classList.add("is-selected");
            radio = element.querySelector("input[type='radio']");
            radio.checked = true;
        }
    }

    _handleSUbmitButton() {
        const form = this._form;
        const selectedItems = form.querySelectorAll(".is-selected")[0];
        const submitButton = this._submitButton;

        if ( !submitButton ) {
            //form.submit();
            return;
        } else {
            if ( selectedItems ) {
                submitButton.removeAttribute("disabled");
            } else {
                submitButton.setAttribute( "disabled", true );
            }
        }
    }

    _refreshItems() {
        const form = this._form;
        const selectedItems = form.querySelectorAll(".is-selected");

        for ( let item of selectedItems ) {
            item.classList.remove("is-selected");
            item.querySelector("input[type='radio']").checked = false;
        }
    }
}

function initSelection() {
    const selection = new Selection();
    selection.listenClicks();
}
  
function handleTextareaLimiter( element ) {

    const counter = document.querySelector('.js-textarea-counter');
    const lengthLabel = document.querySelector(".js-textarea-max-length");
    const alertMessage = document.querySelector(".js-textarea-alert");
    const submitButton = document.querySelector(".js-select-submit-button");

    handleCounter();

    element.addEventListener("input", () => handleCounter());

    function handleCounter() {
        let maxLength;
        let charSum;
        let text;

        maxLength = +element.getAttribute("maxlength");
        text = element.textContent || element.value;
        charSum = getCharSum( text );
        counter.textContent = charSum;
        lengthLabel.textContent = maxLength;

        if ( charSum > 0 ) {
            handleSubmitButton( true );
        } else {
            handleSubmitButton( false );
        }

        if ( charSum >= maxLength ) {
            handleAlertMessage( true );
        } else {
            handleAlertMessage( false );
        }
    }

    function handleSubmitButton( isEnabled ) {
        if ( isEnabled ) {
            submitButton.removeAttribute("disabled");
        } else {
            submitButton.setAttribute( "disabled", true );
        }
    }

    function handleAlertMessage( isVisible ) {
        if ( isVisible ) {
            alertMessage.hidden = false;
        } else {
            alertMessage.hidden = true;
        }
    }

    function getCharSum( string ) {
        let counter = 0;

        while( string[ counter ] ) {
            counter++;
        }

        return counter;
    }
}

export default { animateItems, initSelection, handleTextareaLimiter  }